import fvScript from "./script/fvScript.js";
import Vue from 'vue';
export default class fvObject {
    constructor(wContent){
        this.mixin(wContent);
        this.fvScript = Vue.prototype.fvScript;
    }
    //混入属性
    mixin(src) {
        for (var key in src) {
            this[key] = src[key]
        }
    }
    async executionScript(str){
        return await this.fvScript.executionScript(str)
    }
    show(){
        console.error("虚函数不可直接调用");
    }
}


// WEBPACK FOOTER //
// ./src/js/fvObject.js